import React from "react";
import { List, ListItem, ListItemText } from "@mui/material";
import { useDispatch } from "react-redux";
import { logout } from "../../State/Auth/Action";
import { useNavigate } from "react-router-dom";

const items = [
    { label: "Personal Details", href: "/account" },
    { label: "Order History", href: "/account/order-history" },
    { label: "Manage Addresses", href: "/account/addresses" },
    { label: "My Wishlist", href: "/account/wishlist" },
];

function AccountSidebarNav({ active = "Personal Details" }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
        window.location.reload();
    };

    const itemSx = (isActive) => ({
        paddingY: "8px",
        cursor: "pointer",
        color: isActive ? "#BB3D1F" : "#333",
        "&:hover": {
            color: "#BB3D1F",
            backgroundColor: "transparent",
        },
        "& .MuiListItemText-primary": {
            fontFamily: "'Be Vietnam Pro', sans-serif",
            fontSize: 14,
            fontWeight: isActive ? 500 : 300,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
        },
    });

    return (
        <List
            sx={{
                display: "flex",
                flexDirection: "column",
                padding: 0,
            }}
        >
            {items.map(({ label, href }) => {
                const isActive = label === active;
                return (
                    <ListItem
                        key={label}
                        disableGutters
                        onClick={() => navigate(href)}
                        sx={itemSx(isActive)}
                    >
                        <ListItemText primary={label} sx={{ margin: 0 }} />
                    </ListItem>
                );
            })}

            <ListItem
                onClick={handleLogout}
                disableGutters
                sx={itemSx(false)}
            >
                <ListItemText primary="Logout" sx={{ margin: 0 }} />
            </ListItem>
        </List>
    );
}

export default AccountSidebarNav;
